import client from './client';

import { Emission, PaginationResponse } from '../interfaces';

const getLatestEmission = async () => {
  // Construct the query parameters

  const res = await client.get<PaginationResponse<Emission[]>>(
    '/api/daily-emissions?filters[status]=SUCCESS&sort[0]=date:desc'
  );

  return res.data;
};

export { getLatestEmission };
